import { Subscription, Subject } from "rxjs";
import { ITutorial } from "./tutorial-if";

export class TutorialStaticProps {
  public static running = false;
  public static tutorialTitle = '';
  public static steps: ITutorial.Step[] = [];
  public static currentStep = 0;
  public static observeStepNoElement$: Subject<any> = new Subject<any>();
  public static subObserveStepNoElement: Subscription;
  public static readonly DEFAULT_CUSTOM_HEIGHT = 240;
  public static customHeight = 240;
}
